var MediaType = /* @__PURE__ */ ((MediaType2) => {
  MediaType2["AUDIO"] = "music";
  MediaType2["VIDEO"] = "video";
  MediaType2["IMAGE"] = "picture";
  MediaType2["DOCUMENT"] = "document";
  return MediaType2;
})(MediaType || {});
const MEDIA_SERVICES_URL = "/_serverless/ricos-media-services";
export {
  MEDIA_SERVICES_URL,
  MediaType
};
//# sourceMappingURL=consts.js.map
